<template>
  <div :class="[`page-${currentPageState}`]">
    <!-- 顶部介绍 -->
    <!-- <div class="topView">
      <div class="contentBox" v-for="(item, index) in CONTENT_BOX" :key="index">
        <img :src="item?.icon" />
        <div class="left">
          <div class="label">{{ item?.label || "" }}</div>
          <div class="desc">{{ item?.desc || "" }}</div>
        </div>
      </div>
    </div> -->

    <div
      v-if="currentPageState === PAGE_STATE['NORMAL']"
      class="bottomViewRenew"
      :style="{ marginTop: 35 + statusBarHeight + 'px' }"
    >
      <!-- 选择层 -->
      <div class="chooseView">
        <!-- 左边 -->
        <div class="left">
          <div class="back" @click="handleBack"></div>
          <div class="label-2">Continue Staking</div>
          <div class="label">Choose a Gen2 Yuli</div>
          <!-- 已选择Yuli -->
          <div v-if="!!currentYuli" class="contentView">
            <div class="left">
              <img
                class="mainImg"
                :src="
                  require('@/assets/images/YuliApp/YuliStaking/yuliBg_Staking.png')
                "
              />
              <img
                class="yuli"
                :src="currentYuli?.image"
                v-if="currentYuli?.image"
              />
            </div>
            <div class="right">
              <!-- 顶部编号 -->
              <div class="right-topView">
                <div class="right-topView-block"></div>
                <div class="right-topView-id">#{{ currentYuli?.token_id }}</div>
              </div>
              <div class="right-line"></div>
              <!-- 中部属性 -->
              <div class="right-midView">
                <div class="right-midView-level">
                  Lv.{{ currentYuli?.level || 1 }}
                </div>
                <div class="right-midView-innerRow">
                  <div class="right-midView-label">
                    {{ currentYuli?.role_property_name || "" }}
                  </div>
                  <img
                    class="right-midView-tag"
                    :src="
                      require(`@/assets/images/YuliApp/common/Yuli/property/icon_${currentYuli?.role_property_name}.png`)
                    "
                    v-if="currentYuli?.role_property_name"
                  />
                </div>
                <div class="right-midView-innerRow">
                  <div class="right-midView-label">
                    {{ toFirstUpperUtil(currentYuli?.role_type_name || "") }}
                  </div>
                  <img
                    class="right-midView-tag"
                    :src="
                      require(`@/assets/images/YuliApp/common/Yuli/type/${currentYuli?.role_type_name}.png`)
                    "
                    v-if="currentYuli?.role_type_name"
                  />
                </div>
              </div>
              <div class="right-line"></div>
              <!-- 底部收益 -->
              <div class="right-bottomView">
                <div class="right-bottomView-innerRow">
                  <div class="right-bottomView-num">
                    {{ currentYuli?.passcardMap?.[currentTimeType] }}
                  </div>
                  <div class="right-bottomView-text">
                    Passcard/{{ currentTimeType }}Days
                  </div>
                </div>
                <div class="right-bottomView-innerRow">
                  <div class="right-bottomView-num">
                    {{ currentRewardMap[rewardType.Art] }}
                  </div>
                  <div class="right-bottomView-text">ART/Day</div>
                </div>
                <div class="right-bottomView-innerRow">
                  <div class="right-bottomView-num">375</div>
                  <div class="right-bottomView-text">EXP/Day</div>
                </div>
                <!-- <div
                  class="right-bottomView-rechoose"
                  @click="showChooseHanlde"
                >
                  Re-choose
                </div> -->
              </div>
            </div>
          </div>
          <!-- 无选择Yuli -->
          <!-- :style="{ cursor: 'pointer' }" -->
          <div v-if="!currentYuli" class="contentView">
            <div class="left" @click="showChooseHanlde">
              <img
                class="mainImg"
                :src="
                  require('@/assets/images/YuliApp/YuliStaking/yuli_add.png')
                "
              />
            </div>
            <div :class="['right', 'nodataRight']">
              {{ `Click the add\nbutton on the left\nto select yuli` }}
            </div>
          </div>
        </div>
        <!-- 右边 -->
        <div class="right">
          <div class="label">Choose Staking Plan</div>
          <div class="contentView">
            <div
              :class="['timeItem', currentTimeType == item.key && 'timeActive']"
              v-for="(item, index) in timeTypeGroup"
              :key="index"
              @click="handleSetPlan(item)"
            >
              {{ item?.label || "" }}
            </div>
          </div>
        </div>
      </div>
      <!-- 奖励层 -->
      <div class="rewardView">
        <!-- arg消耗 -->
        <div class="contentView">
          <div class="label">Consumption:</div>
          <div class="mainContent">
            <div class="argView">
              <div
                :class="['argIcon', dpIsShowArgDiscount() && 'argDiscount']"
                :style="{
                  '--contentText': `'${parseFloat(
                    (((discountMapValue?.discount || 1) - 1) * 100).toFixed(10)
                  )}%'`,
                }"
              >
                <img
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_arg.png')
                  "
                />
              </div>
              <div :class="['have', !dpEnableArgValue() && 'numberRed']">
                {{ Number(argHave).toFixed(2) }}
              </div>
              <div class="mid">/</div>
              <div class="need" v-if="dpIsShowArgDiscount()">
                {{ floatMulUtil(argNeed, discountMapValue?.discount || 1) }}
              </div>
              <div :class="['need', dpIsShowArgDiscount() && 'discount']">
                {{ parseFloat(Number(argNeed).toFixed(10)) }}
              </div>
              <div class="coin">ARG</div>
            </div>
          </div>
          <div class="mainContent">
            <div class="propView" v-if="dpIsShowArgDiscount()">
              <div class="propIcon">
                <img
                  :src="discountMapValue?.icon"
                  v-if="discountMapValue?.icon"
                />
              </div>
              <div class="propValue">{{ `${discountMapValue?.count}/1` }}</div>
              <div class="wenhao" @touchstart="() => {}">
                <img
                  :src="
                    require('@/assets/images/YuliApp/YuliStaking/icon_wenhao.png')
                  "
                />
                <div class="tips">
                  You have a discount coupon and there is only
                  <span :style="{ color: '#E40000' }"
                    >{{ (discountMapValue?.discount || 1) * 100 }}%</span
                  >
                  Consumption
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 其他奖励 -->
        <div class="contentView">
          <div class="label">Expected revenue:</div>
          <div class="mainContent">
            <div class="item" v-for="(item, index) in rewardGroup" :key="index">
              <img :src="item?.icon" v-if="item?.icon" />
              <div class="num">
                {{
                  NumberFormatUtil(
                    parseFloat(
                      Number(
                        currentRewardMap[item.name] *
                          (item.name !== rewardType.Passcard
                            ? currentTimeType
                            : 1)
                      ).toFixed(10)
                    ),
                    2
                  )
                }}
              </div>
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <!-- 底部按钮 -->
        <div class="buttonView">
          <div
            :class="['button', (!currentYuli || !dpEnableArgValue()) && 'ban']"
            @click="handleStakeClick"
          >
            <div class="button-text" v-show="!isLoading">Approve</div>

            <div class="button-loading" v-show="isLoading"></div>
          </div>
          <div :class="['tipsView', !dpEnableArgValue() && 'textRed']">
            {{
              `${
                dpEnableArgValue()
                  ? "Passcard and ART will be able to claim after the due date."
                  : "Sorry, you don't have enough ARG to continue currently"
              }`
            }}
          </div>

          <div class="errorTipsView" v-if="isShowErrorMsg">
            Transaction failed, please try again later!
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="currentPageState === PAGE_STATE['SUCCESS']"
      class="bottomViewRenew"
    >
      <div class="stakingView">
        <img
          class="stakingIcon"
          :src="
            require('@/assets/images/YuliApp/YuliStaking/icon_staking_success.png')
          "
        />
        <div class="label">Congrats!</div>
        <div class="desc">
          You have continued to stake the current Yuli And your ART and EXP
          rewards has been claimed in the meantime.
        </div>
        <div class="button" @click="handleStakSuccess">
          <div class="button-text">Continue</div>
        </div>
      </div>
    </div>

    <div
      v-if="currentPageState === PAGE_STATE['FAILED']"
      class="bottomViewRenew"
    >
      <div class="stakingView">
        <img
          class="stakingIcon"
          :src="
            require('@/assets/images/YuliApp/YuliStaking/icon_staking_failed.png')
          "
        />
        <div class="label">Sorry</div>
        <div class="desc">Transaction failed, you need to try again</div>
        <div class="button" @click="handleStakError">
          <div class="button-text">Try again</div>
        </div>
      </div>
    </div>

    <div v-if="isShowPopup">
      <!-- <YuliChoosePopup
        @onClose="handleYuliChoosePopupClose"
        @onSelect="chooseHandle"
      /> -->
    </div>

    <div v-if="isShowComfirm">
      <div class="comfirmPopup">
        <div class="mask"></div>
        <div class="popup">
          <div class="closeIcon" @click="handleComfirmPopupClose"></div>
          <div class="title">Confirm Stake?</div>
          <div class="content">
            <div class="block">
              During the staking period, Gen2 Yuli cannot participate in
              purifying, be listed in the marketplace or redeemed to BNB Chain.
              <br /><br />Do you want to continue?
            </div>
            <div class="btn-list">
              <div
                :class="['btn', 'btn-cancel']"
                @click="handleComfirmPopupClose"
              >
                <div class="btn-text">Cancel</div>
              </div>
              <div :class="['btn']" @click="handleStakingComfirm">
                <div class="btn-text">Confirm</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onMounted, ref } from "vue";
import {
  TIME_TYPE,
  REWARD_TYPE,
  YULI_QUALITY_TYPE,
  TIME_TYPE_GROUP,
  REWARD_GROUP,
  DISCOUNT_PROP_MAP,
} from "@/components/YuliStaking/constants/type.js";
import { toFirstUpper, NumberFormat } from "@/utils/utils.js";
import { ARG_COST_MAP } from "@/components/YuliStaking/constants/incomeMap.js";
import {
  getWallet,
  getUserProps,
  postYOG2StakingRecord,
  postYOG2StakingRenew,
} from "@/api/staking.js";
import { floatMul } from "@/utils/math.js";

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
    data: {
      async handler(value) {
        if (value) {
          if (!value) return;
          this.currentYuli = value;
          this.dataRecover();

          this.chooseHandle(value);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const CONTENT_BOX = [
      {
        icon: require("@/assets/images/YuliApp/YuliStaking/icon_passcard_label.png"),
        label: "Earn Passcard",
        desc: "Stake Gen2 Yuli and you will earn Yuli Passcard",
      },
      {
        icon: require("@/assets/images/YuliApp/YuliStaking/icon_artexp_label.png"),
        label: "Remain Purification Rewards",
        desc: "You will continue to earn $ART Token and Yuli EXP during stake period without consumption",
      },
    ];

    const PAGE_STATE = {
      NORMAL: "NORMAL",
      SUCCESS: "SUCCESS",
      FAILED: "FAILED",
    };

    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const currentTimeType = ref(TIME_TYPE["days60"]);
    const currentPageState = ref(PAGE_STATE["NORMAL"]);
    const currentYuli = ref(null);
    const currentMap = ref(null);
    const currentRewardMap = ref({
      [REWARD_TYPE.Passcard]: 0,
      [REWARD_TYPE.Art]: 0,
      [REWARD_TYPE.YuliExp]: 0,
    });
    const isShowPopup = ref(false);
    const isLoading = ref(false);
    const isShowErrorMsg = ref(false);
    const argHave = ref(0);
    const argNeed = ref(0);
    const discountHadMap = ref(null);
    const currentPropType = ref(YULI_QUALITY_TYPE["WHITE"]); // 道具类型
    const discountMapValue = ref(discountHadMap.value?.[currentPropType.value]);
    const timeTypeGroup = ref(TIME_TYPE_GROUP);
    const rewardGroup = ref(REWARD_GROUP);
    const rewardType = ref(REWARD_TYPE);
    const isShowComfirm = ref(false);

    const toFirstUpperUtil = toFirstUpper;
    const NumberFormatUtil = NumberFormat;
    const floatMulUtil = floatMul;

    onMounted(() => {});

    const handleBack = () => {
      emit("onClose");
    };

    const handleShowComfirmPopup = () => {
      isShowComfirm.value = true;
    };

    const handleComfirmPopupClose = () => {
      isShowComfirm.value = false;
    };

    const handleStakingComfirm = () => {
      isShowComfirm.value = false;

      stakeHandle();
    };

    /** 展示弹窗处理*/
    const showChooseHanlde = () => {
      isShowPopup.value = true;
    };

    /**
     * 处理弹窗关闭
     */
    const handleYuliChoosePopupClose = () => {
      isShowPopup.value = false;
    };

    /**
     * 处理当前计划选择
     */
    const handleSetPlan = (item) => {
      if (!currentYuli.value) return;
      const key = item?.key;
      currentRewardMapHandle(null, null, key);
    };

    /**
     * 设置当前ARG花费
     */
    const argCostHandle = (yuli, time) => {
      const role_type =
        yuli?.role_type_name || currentYuli.value?.role_type_name;
      const useTimeType = time || currentTimeType.value;
      const curTypeArgCostMap = ARG_COST_MAP?.[role_type];
      const curTimeArgCostValue = curTypeArgCostMap?.[useTimeType];
      argNeed.value = curTimeArgCostValue;
    };

    /**
     * 设置当前奖励
     */
    const currentRewardMapHandle = (
      passcardMap,
      artMap,
      timeType,
      yuliData
    ) => {
      if (!passcardMap) passcardMap = currentMap.value?.passcardMap || {};
      if (!artMap) artMap = currentMap.value?.artMap || {};
      let useTimeType = currentTimeType.value;
      if (timeType) {
        useTimeType = timeType;
        currentTimeType.value = timeType;
      }
      let useYuliData = currentYuli.value;
      if (yuliData) useYuliData = yuliData;
      argCostHandle(useYuliData, useTimeType);
      const params = {
        [REWARD_TYPE.Passcard]: passcardMap?.[useTimeType] || 0,
        [REWARD_TYPE.Art]: artMap?.[useYuliData?.level] || 0,
        [REWARD_TYPE.YuliExp]: useYuliData ? 375 : 0,
      };
      currentRewardMap.value = params;
    };

    /**
     * 是否存在优惠券
     */
    const dpIsShowArgDiscount = () => {
      return discountMapValue.value?.count > 0 && currentYuli.value;
      // return true;
    };

    /** 判断是否足够arg*/
    const dpEnableArgValue = () => {
      return (
        Number(argHave.value) >=
        (discountMapValue.value?.count > 0
          ? argNeed.value * (discountMapValue.value?.discount || 1)
          : argNeed.value)
      );
    };

    /**
     * 处理质押成功按钮
     */
    const handleStakSuccess = () => {
      emit("onRenewSuccess");
    };

    /**
     * 处理质押失败按钮
     */
    const handleStakError = () => {
      currentPageState.value = PAGE_STATE.NORMAL;
    };

    /**
     * 处理错误
     */
    const handleError = () => {
      isLoading.value = false;
      isShowErrorMsg.value = true;
      setTimeout(() => {
        isShowErrorMsg.value = false;
      }, 3000);
    };

    /**
     * 获取当前拥有的货币值 与持有道具
     */
    const handleGetCurrency = async () => {
      try {
        const respons = (await getWallet()) || {};
        const res = respons?.data || {};
        const arg = res?.arg || 0;
        const art = res?.art || 0;
        argHave.value = arg;

        // 折扣券信息
        const props_response = await getUserProps();
        const props_list = props_response?.data || [];
        const useDiscountMap = {};
        if (props_list?.length > 0) {
          const yuliTypeGroup = Object.keys(DISCOUNT_PROP_MAP);
          yuliTypeGroup.forEach((key, index) => {
            // 对应不同品阶道具
            const curDiscount = DISCOUNT_PROP_MAP[key];
            const curDiscountPropId = curDiscount?.prop_id;
            const findDex = props_list?.findIndex(
              (item) => item?.id == curDiscountPropId
            );

            if (findDex > -1) {
              useDiscountMap[key] = {
                ...props_list[findDex],
                ...curDiscount,
              };
            }
          });
        }

        discountHadMap.value = useDiscountMap;
        discountMapValue.value = useDiscountMap?.[currentPropType.value];
      } catch (error) {
        console.log(error);
      }
    };

    /** 数据恢复*/
    const dataRecover = async () => {
      isLoading.value = false;
      isShowErrorMsg.value = false;
      currentMap.value = null;
      currentYuli.value = null;
      argNeed.value = 0;
      discountHadMap.value = {};

      currentTimeType.value = TIME_TYPE.days60;
      currentPageState.value = PAGE_STATE.NORMAL;
      currentRewardMap.value = {
        [REWARD_TYPE.Passcard]: 0,
        [REWARD_TYPE.Art]: 0,
        [REWARD_TYPE.YuliExp]: 0,
      };

      await handleGetCurrency();
    };

    /**
     * 处理Yuli选择
     */
    const chooseHandle = (item) => {
      currentYuli.value = item;
      currentMap.value = {
        passcardMap: item?.passcardMap,
        artMap: item?.artMap,
      };

      argCostHandle(item);
      currentRewardMapHandle(item?.passcardMap, item?.artMap, null, item);

      handleYuliChoosePopupClose();
    };

    /**
     * 处理质押
     */
    const stakeHandle = async () => {
      if (isLoading.value) return;
      if (!currentYuli.value || !dpEnableArgValue()) return;

      try {
        isLoading.value = true;

        let usePropId = "0";
        if (
          discountMapValue.value?.prop_id &&
          discountMapValue.value.prop_id !== "" &&
          discountMapValue.value?.count > 0
        ) {
          usePropId = discountMapValue.value.prop_id;
        }

        const id = currentYuli.value?.token_id;
        const timeType = currentTimeType.value;
        const prop = usePropId;

        setTimeout(() => {}, 1000);

        // 折扣道具服务端自动扣除
        // 续期
        const record_id = currentYuli.value?.record?.id;

        const res = await postYOG2StakingRenew(record_id, {
          token_id: id,
          duration: timeType,
        });

        // 成功
        currentPageState.value = PAGE_STATE.SUCCESS;
      } catch (error) {
        // 失败
        currentPageState.value = PAGE_STATE.FAILED;
        // handleError();
      } finally {
        isLoading.value = false;
      }
    };

    const handleStakeClick = () => {
      if (isLoading.value) return;
      if (!currentYuli.value || !dpEnableArgValue()) return;

      isShowComfirm.value = true;
    };

    return {
      localesPackage,
      localesEnv,
      CONTENT_BOX,
      PAGE_STATE,
      currentTimeType,
      currentPageState,
      currentYuli,
      currentMap,
      currentRewardMap,
      isShowPopup,
      isLoading,
      isShowErrorMsg,
      argHave,
      argNeed,
      discountHadMap,
      currentPropType,
      discountMapValue,
      timeTypeGroup,
      rewardGroup,
      rewardType,
      toFirstUpperUtil,
      NumberFormatUtil,
      floatMulUtil,
      showChooseHanlde,
      handleYuliChoosePopupClose,
      handleSetPlan,
      currentRewardMapHandle,
      argCostHandle,
      dpIsShowArgDiscount,
      dpEnableArgValue,
      handleStakSuccess,
      handleStakError,
      handleError,
      dataRecover,
      chooseHandle,
      stakeHandle,
      isShowComfirm,
      handleShowComfirmPopup,
      handleComfirmPopupClose,
      handleStakingComfirm,
      handleStakeClick,
      handleBack,
    };
  },
};
</script>

<style lang="less" scoped>
.page-NORMAL {
  flex: 1;
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 999;
  background-color: #0f193b;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: scroll;

  .topView {
    width: 100%;
    height: 197px;
    // margin-bottom: 2px;
    padding-top: 15px;
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
    background: #12426d;
    border-bottom: 2px solid #0f193b;

    .contentBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-bottom: 18px;
      min-width: 207px;
      max-width: 234px;
      margin-left: 32px;

      img {
        width: 70px;
        height: 70px;
        margin-right: 10px;
      }

      .left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        color: #ffffff;
        text-align: left;
        font-family: "Inter";
        font-style: normal;

        .label {
          height: 30px;
          font-size: 14px;
          font-weight: 600;
          line-height: 30px;
        }
        .desc {
          color: #aae1ff;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          min-width: 207px;
        }
      }
    }
  }

  .bottomViewRenew {
    width: 100%;
    // height: 770px;
    background: linear-gradient(180deg, #12416c 0%, #1e779f 100%);
    // padding: 15px 25px 75px;
    padding: 15px;
    box-sizing: border-box;
    position: relative;
    overflow-x: hidden;

    .chooseView {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .label-2 {
        color: #ffffff;
        font-family: "Tomorrow";
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 19.2px;
        text-transform: uppercase;
        text-align: right;
        position: absolute;
        right: 15px;
        top: 10px;
      }

      .left,
      .right {
        .label {
          color: #ffffff;
          font-family: "Tomorrow";
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 19.2px;
          text-transform: uppercase;
          text-align: left;
        }
      }

      .left {
        width: 100%;
        box-sizing: border-box;

        .label {
          padding-top: 15px;
          margin-top: 38px;
          border-top: 1px solid #468fc2;
        }

        .back {
          width: 81px;
          height: 26px;
          background-image: url("~@/assets/images/YuliApp/YuliStaking/myStaking/icon_back.png");
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 1;
          position: absolute;
          left: -10px;
          top: 6px;
        }

        .contentView {
          margin-top: 9px;
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;
          height: 244px;
          background: #226b99;
          border: 0.5px solid #64a7d4;
          @leftWitdh: 183px;

          .left {
            width: @leftWitdh;
            height: 100%;
            position: relative;

            .mainImg {
              width: 100%;
              height: 100%;
            }

            .yuli {
              position: absolute;
              top: 25px;
              left: 50%;
              transform: translateX(-50%);
              width: 200px;
              height: 200px;
            }
          }

          .right {
            height: 100%;
            width: calc(100% - @leftWitdh);
            white-space: pre-wrap;
            padding: 10px 4px 11px 7px;

            &-topView {
              display: flex;
              align-items: center;
              margin-bottom: 8px;

              &-block {
                width: 3px;
                height: 12px;
                background: #57ffeb;
                margin-right: 3px;
              }

              &-id {
                color: #7be9ff;
                font-family: "Inter";
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
            }

            &-line {
              margin-bottom: 7px;
              width: 100%;
              background: #2f77a7;
              height: 1px;
            }

            &-midView {
              width: 100%;
              padding: 0 8px;
              color: #7be9ff;
              font-family: "Inter";
              font-size: 13px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              box-sizing: border-box;

              &-innerRow {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 10px;
              }

              &-level {
                margin-left: -4px;
                margin-bottom: 8px;
                text-align: left;
              }

              &-tag {
                width: 20px;
                height: 20px;
              }
            }

            &-bottomView {
              width: 100%;
              padding: 0 8px;
              color: #7be9ff;
              font-family: "Inter";
              font-size: 10px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              box-sizing: border-box;

              &-innerRow {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 6px;

                &:last-child {
                  margin-bottom: unset;
                }
              }

              &-num {
                color: #ffffff;
                font-size: 14px;
                font-weight: 600;
              }

              &-rechoose {
                margin: 0 auto;
                width: 100px;
                height: 24px;
                border: 1px solid #00ffe0;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #00ffe0;
                font-family: "Tomorrow";
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                // cursor: pointer;
              }
            }
          }

          .nodataRight {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            color: #62a0c2;
            font-family: "Inter";
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
          }
        }
      }

      .right {
        margin-top: 13px;
        width: 100%;

        .contentView {
          margin-top: 9px;
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          flex-wrap: wrap;

          .timeItem {
            width: 160px;
            height: 52px;
            background-image: url("~@/assets/images/YuliApp/YuliStaking/dayItemBgOff.png");
            background-size: 100% 100%;
            padding: 14px 24px 16px;
            padding-right: unset;
            color: #53d3ef;
            font-family: "Inter";
            font-size: 16px;
            font-weight: 600;
            // cursor: pointer;
            margin-bottom: 6px;
            margin-right: 5px;
            box-sizing: border-box;
            text-align: left;

            &:nth-child(2n) {
              margin-right: 0px;
            }
          }

          .timeActive {
            background-image: url("~@/assets/images/YuliApp/YuliStaking/dayItemBgOn.png");
            background-size: 100% 100%;
            color: #00ffe0;
          }
        }
      }
    }

    .rewardView {
      width: 100%;
      margin-top: 20px;

      .contentView {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: "Inter";
        font-size: 14px;
        font-weight: 400;
        line-height: 30px;
        color: #7be9ff;
        position: relative;
        white-space: nowrap;

        .label {
          width: 100%;
          height: 30px;
          text-align: left;
          height: 30px;
          font-size: 13px;
          color: #7be9ff;
        }

        .mainContent {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          justify-content: flex-start;
          flex-wrap: wrap;
          width: 100%;

          .item {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-right: 10px;

            &:last-child {
              margin-right: unset;
            }

            img {
              width: 24px;
              height: 24px;
              margin-right: 4px;
            }
            .num {
              margin-right: 4px;
            }
          }

          .argView {
            display: flex;
            align-items: center;
            justify-content: center;

            .argIcon {
              width: 24px;
              height: 24px;
              margin-right: 4px;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 100%;
                height: 100%;
              }
            }

            .argDiscount {
              position: relative;
              --contentText: "80%";

              &::after {
                width: 30px;
                height: 16px;
                content: var(--contentText);
                color: #ffffff;
                font-family: "Inter";
                font-size: 10px;
                font-weight: 700;
                display: flex;
                padding: 2px 4px;
                justify-content: center;
                align-items: center;
                position: absolute;
                left: -3px;
                top: -8px;
                border-radius: 25px;
                background: #d44040;
              }
            }

            .mid {
              margin: 0 4px;
            }

            .coin {
              margin-left: 4px;
            }

            .discount {
              margin-left: 4px;
              text-decoration: line-through;
              color: #64a7d4;
            }

            .numberRed {
              color: #ffa7a7;
            }
          }

          .propView {
            display: flex;
            align-items: center;
            justify-content: center;
            // margin-left: 15px;

            .propIcon {
              margin-right: 4px;
              width: 24px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 100%;
                height: 100%;
              }
            }

            .wenhao {
              width: 16px;
              height: 16px;
              margin-left: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;

              img {
                width: 100%;
                height: 100%;
              }

              .tips {
                position: absolute;
                width: 177px;
                height: 68px;
                color: #000000;
                font-family: "Inter";
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                padding: 4px 10px;
                background: #7be9ff;
                left: -70px;
                top: -77px;
                display: none;
                position: absolute;
                white-space: pre-line;
              }

              &:hover,
              &:active {
                .tips {
                  display: unset;
                }
              }
            }
          }
        }
      }

      .buttonView {
        margin-top: 22px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        position: relative;

        .tipsView {
          color: #aae1ff;
          // position: absolute;
          // bottom: -40px;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
          margin-top: 20px;
          margin-bottom: 20px;
        }

        .textRed {
          color: #ffa7a7;
        }

        .errorTipsView {
          position: absolute;
          top: -70px;
          left: 50%;
          transform: translateX(-50%);
          width: 100vw;
          height: 60px;
          background-image: url("~@/assets/images/YuliApp/YuliStaking/error_bg.png");
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          text-align: center;
          font-family: "Inter";
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 19.2px;
        }
      }
    }

    .button {
      width: 214px;
      height: 40px;
      background-image: url("~@/assets/images/YuliApp/YuliStaking/btn_bg.png");
      background-size: 100% 100%;
      // cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-text {
        color: #0f193b;
        font-family: "Tomorrow";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
      }

      &-loading {
        width: 28px;
        height: 28px;
        background-image: url("~@/assets/images/YuliApp/common/loading/icon_loading@2x.png");
        background-size: 100% 100%;
        background-position: center;
        animation: rotate 1s linear infinite;

        @keyframes rotate {
          from {
            transform-origin: center center;
            transform: rotate(0deg);
          }
          to {
            transform-origin: center center;
            transform: rotate(360deg);
          }
        }
      }
    }

    .ban {
      opacity: 0.5;
      cursor: unset;
    }
  }

  .comfirmPopup {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 999;

    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      backdrop-filter: blur(7.5px);
      top: 0;
      left: 0;
      animation: maskFade 0.1s ease-in-out;

      @keyframes maskFade {
        0% {
          background: rgba(0, 0, 0, 0);
        }
        100% {
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }

    .popup {
      position: relative;
      width: 355px;
      height: 320px;
      opacity: 1;
      background-image: url("~@/assets/images/YuliApp/YuliStaking/choose_popup_bg_s.png");
      background-size: 100% 100%;
      color: rgb(255, 255, 255);
      font-family: "Inter";
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;

      .closeIcon {
        position: absolute;
        height: 30px;
        width: 30px;
        top: 5px;
        right: 5px;
        cursor: pointer;
      }

      .title {
        margin-top: 29px;
        color: #ffffff;
        font-family: "Inter";
        font-size: 18px;
        font-size: 16px;
        font-weight: 500;
        line-height: 28px;
      }

      .content {
        width: 100%;
        height: 100%;
        margin-top: 20px;
        margin-bottom: 10px;
        // overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        .block {
          width: 283px;
          color: #aae1ff;
          font-family: "Inter";
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-align: left;
          box-sizing: border-box;
        }

        .btn-list {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-top: 59px;

          .btn {
            width: 140px;
            height: 38px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #00ffe0;
            border-radius: 4px;

            &-text {
              color: #0f193b;
              text-align: center;
              font-family: "Tomorrow";
              font-size: 15px;
              font-style: normal;
              font-weight: 500;
              line-height: 37.5px;
            }

            &-cancel {
              width: 170px;
              background: #faf4f4;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}

.page-SUCCESS,
.page-FAILED {
  // flex: 1;
  // width: 100%;
  // height: 100%;
  position: relative;
  box-sizing: border-box;
  position: fixed;
  top: 250px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 999;
  background-color: #0f193b;
  padding: 10px;
  overflow-y: scroll;

  .bottomViewRenew {

    .stakingView {
      min-width: 350px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #7be9ff;
      text-align: center;
      font-family: "Inter";
      font-weight: 400;
      line-height: 14px;
      padding-top: 50px;
      padding-bottom: 50px;
      background: linear-gradient(180deg, #12416c 0%, #1e779f 100%);

      .stakingIcon {
        width: 120px;
        height: 120px;
        margin-bottom: 36px;
      }

      .label {
        font-size: 20px;
        margin-bottom: 15px;
      }

      .desc {
        width: 301px;
        font-size: 14px;
        margin-bottom: 88px;
      }
    }

    .button {
      width: 214px;
      height: 40px;
      background-image: url("~@/assets/images/YuliApp/YuliStaking/btn_bg.png");
      background-size: 100% 100%;
      // cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-text {
        color: #0f193b;
        font-family: "Tomorrow";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
      }

      &-loading {
        width: 28px;
        height: 28px;
        background-image: url("~@/assets/images/YuliApp/common/loading/icon_loading@2x.png");
        background-size: 100% 100%;
        background-position: center;
        animation: rotate 1s linear infinite;

        @keyframes rotate {
          from {
            transform-origin: center center;
            transform: rotate(0deg);
          }
          to {
            transform-origin: center center;
            transform: rotate(360deg);
          }
        }
      }
    }
  }
}
</style>
